<template>
  <div id="app">
    <ComHeader v-if="!(path === '/login'|| path === '/enroll' || path === '/personLogin') && isRouterAlive_header"></ComHeader>
    <router-view v-bind:style="{ minHeight: Height + 'px' }" v-if="isRouterAlive"/>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import comHeader from "@/components/ComHeader";
import comFooter from "@/components/ComFooter";
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
      reload_header: this.reload_header
    }
  },
  data() {
     return {
       Height: 0,
       isRouterAlive: true,
       path:'',
       isRouterAlive_header:true
     }
  },
  // mounted(){
  //   console.log(this.$route.path);
  //   this.path = this.$route.path;

  // },
  watch:{
    $route(to,from){
      this.path = to.path;
    }
  },
  mounted(){
    // console.log(this.$route.path);
    // this.path = this.$route.path;
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 130;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -130}
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    reload_header () {
      this.isRouterAlive_header = false
      this.$nextTick(function () {
        this.isRouterAlive_header = true
      })
    }
  },
  components: {
    comHeader,
    comFooter,
  },
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/App.vue